import MasterUserPage from './pages/master/MasterUserPage';
import { Inventory, PeopleAlt } from '@mui/icons-material';
import MasterTenantPage from './pages/master/MasterTenantPage';
import BatchOperationPage from './pages/master/BatchOperationPage';
import TenantBatchOperationPage from './pages/master/TenantBatchOperationPage';
import HangfireLoglamaPage from './pages/master/HangfireLoglamaPage';
import WorkerPlannedJobPage from './pages/master/WorkerPlannedJobPage';
import SysGlobalKeyPage from './pages/master/SysGlobalKeyPage';
import SGKMasterParameterPage from './pages/master/SGKMasterParameterPage';
import useGlobal from './util/Global';



const MasterRouter = [
    {
        title: 'masterMenu.masterTenant',
        path: '/masterTenant',
        component: MasterTenantPage,
        useGlobal: true,
        icon: <Inventory />,
    },

    {
        title: 'masterMenu.masterUser',
        path: '/masterUser',
        component: MasterUserPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },
    {
        title: 'masterMenu.batchOperations',
        path: '/batchOperation',
        component: BatchOperationPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },
    {
        title: 'masterMenu.tenantBatchOperation',
        path: '/tenantBatchOperation',
        component: TenantBatchOperationPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },
    {
        title: 'masterMenu.hangfireloglama',
        path: '/hangfireloglama',
        component: HangfireLoglamaPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },
    {
        title: 'masterMenu.WorkerPlannedJobPage',
        path: '/WorkerPlannedJobPage',
        component: WorkerPlannedJobPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },
    {
        title: 'masterMenu.SysGlobalKeyPage',
        path: '/SysGlobalKeyPage',
        component: SysGlobalKeyPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },
    {
        title: 'masterMenu.SGKMasterParameter',
        path: '/SGKMasterParameter',
        component: SGKMasterParameterPage,
        useGlobal: true,
        icon: <PeopleAlt />,
    },







];

export default MasterRouter;
